import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './recorded-interview.reducer';

export const RecordedInterviewDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const recordedInterviewEntity = useAppSelector(state => state.recordedInterview.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="recordedInterviewDetailsHeading">
          <Translate contentKey="fivePlusApp.recordedInterview.detail.title">RecordedInterview</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{recordedInterviewEntity.id}</dd>
          <dt>
            <span id="recordedInterviewId">
              <Translate contentKey="fivePlusApp.recordedInterview.recordedInterviewId">Recorded Interview Id</Translate>
            </span>
          </dt>
          <dd>{recordedInterviewEntity.recordedInterviewId}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.recordedInterview.interview">Interview</Translate>
          </dt>
          <dd>{recordedInterviewEntity.interview ? recordedInterviewEntity.interview.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/recorded-interview" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/recorded-interview/${recordedInterviewEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RecordedInterviewDetail;
